import Vue from 'vue'
import cfg from '../../../cfg.json'

Vue.$cfg = cfg
Vue.prototype.$cfg = cfg
